// extracted by mini-css-extract-plugin
export default {"menuPreferencesIcon":"G61cb39"};